Alerts = require 'views/lib/alerts'
ApiError = require 'network/api-error'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
localizeServerError = require 'lib/localize-server-error'
Member = require 'models/member'
PopOver = require 'views/lib/pop-over'
React = require 'react'
t = require('views/internal/recup-with-helpers')('invite_add_name')
track = require 'debug/track'
Util = require 'lib/util'
_ = require 'underscore'

extractFullName = (email) ->
  puncSpacePattern = /[\s\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/
  puncPattern = /[\d\x21-\x2F\x3A-\x40\x5B-\x60\x7B-\x7F]+/

  fullName = _.compact(Util.removeDomainFromEmailAddress(email).split(puncSpacePattern)).join(' ').replace(puncPattern, '')
  Util.toTitleCase(fullName)

validateFullName = (fullName) ->
  !Util.validName(fullName)

module.exports = class extends React.Component
  displayName: 'InviteAddName'

  constructor: (props) ->
    super(props)

    fullName = extractFullName(@props.email)

    @state = {
      err: validateFullName(fullName)
      fullName
    }

  componentWillReceiveProps: ({ email }) ->
    fullName = extractFullName(email)

    @setState {
      err: validateFullName(fullName)
      fullName
    }

  render: t.renderable ->
    { email, model, modelCache } = @props
    { err, fullName, submitting } = @state

    toggleErrClass = if err then '' else '.hide'

    t.div { style: { marginTop: '10px' } }, =>
      t.p '.quiet', ->
        t.format 'we dont know that person…team', { email }

      t.p ".error#{toggleErrClass}", ->
        t.format 'full name too short'

      t.form { @onSubmit }, =>
        t.label ->
          t.format 'full-name'
        t.input { type: 'text', value: fullName, onChange: @onNameChange }
        t.input '.wide.primary', { type: 'submit', disabled: submitting, value: t.l('send') }

  ############################################################################################################
  ############################################################################################################
  ############################################################################################################

  onNameChange: ({ target }) =>
    fullName = target.value

    @setState {
      err: validateFullName(fullName.trim())
      fullName
    }

  onSubmit: (e) =>
    e.preventDefault()

    { err } = @state

    if !err
      @sendEmailInvite()

  sendEmailInvite: (data) =>
    { email, member, model, modelCache } = @props
    { fullName } = @state

    data = { fullName, email, type: 'normal' }

    @setState submitting: true

    ApiPromise
      url: "/1/organizations/#{model.id}/members"
      type: 'put'
      dataType: 'json'
      data: data
    .then (data) =>
      member = new Member(data, { modelCache })
      if !model.memberList.get(member.id)
        model.memberList.add(member)
      track("Invitations", "Send Email Org Invite to New Member", "Role: #{data.type}")

      PopOver.hide()
    .finally =>
        @setState submitting: false
    .catch ApiError, @_handleError

  _handleError: (resOrApiError) =>
    message = localizeServerError(resOrApiError)

    Alerts.showLiteralText(message, 'error', 'alert', 3000)
    track("Invitations", "Error: #{ resOrApiError.message ? resOrApiError.responseText }")



// WEBPACK FOOTER //
// ./app/scripts/views/organization/manage-org-members-component/invite-add-name.coffee